'use strict';

module.exports = /* @ngInject */ ["apiFactory", "AUTH_API_BASE", function (apiFactory, AUTH_API_BASE) {
  var authApiPromise;

  this.create = function () {
    if (!authApiPromise) {
      authApiPromise = apiFactory.create('idpAddress', AUTH_API_BASE);
    }
    return authApiPromise;
  };
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/infrastructure/authApiFactory.js
// module id = 126
// module chunks = 0